module.exports = _;


/*****************
 ** WEBPACK FOOTER
 ** external "_"
 ** module id = 0
 ** module chunks = 2 3
 **/